import { StaticBaseDao } from '@/dao';
import {
    MapTrack,
    TrackingResultSetup,
    IntArray,
    MapPoint,
    GeoFenceRectangle,
    RaceContestantPosition,
    RaceContestantTrackingUpdateRequest,
    SearchRequest,
    TypeAheadResponse,
    EventinfoBase,
} from '@/objects/generated';
import { useUserStore } from '@/stores';

export class TrackDao extends StaticBaseDao {
    public static async GetTracksForEvent(EventId: number): Promise<MapTrack[]> {
        return this.BaseFetchArray(MapTrack, `Track/Event` + '?' + (EventId == undefined ? '' : `EventId=${EventId}`), 'GET');
    }
    public static async UploadFiles(files: FormData, EventID: number): Promise<MapTrack[]> {
        return this.PostFormData(
            MapTrack,
            `Track/UploadFiles` +
                '?' +
                (files == undefined ? '' : `files=${files}`) +
                '&' +
                (EventID == undefined ? '' : `EventID=${EventID}`),
            files,
        );
    }
    public static async SaveTrackingResultSetup(setups: TrackingResultSetup, EventID: number): Promise<number | null | null> {
        return this.Post(`Track/SaveTrackingResultSetup` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`), setups);
    }
    public static async GetTrackingResultSetup(EventID: number): Promise<TrackingResultSetup | null> {
        return this.BaseFetch(
            TrackingResultSetup,
            `Track/GetTrackingResultSetup` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'GET',
        );
    }
    public static async PostTracksForOrganizer(tracks: MapTrack[]): Promise<IntArray | null> {
        return this.BaseFetch(IntArray, `Track/PostTracksForOrganizer`, 'POST', tracks);
    }
    public static async GetTracksForUser(EventId: number, onlyTracksWithCoordinates?: boolean): Promise<MapTrack[]> {
        return this.BaseFetchArray(
            MapTrack,
            `Track/GetTracksForUser` +
                '?' +
                (EventId == undefined ? '' : `EventId=${EventId}`) +
                '&' +
                (onlyTracksWithCoordinates == undefined ? '' : `onlyTracksWithCoordinates=${onlyTracksWithCoordinates}`),
            'GET',
        );
    }
    public static async GetMapPointsForTrack(EventId: number, TrackId: number): Promise<MapPoint[]> {
        return this.BaseFetchArray(
            MapPoint,
            `Track/MapPoints` +
                '?' +
                (EventId == undefined ? '' : `EventId=${EventId}`) +
                '&' +
                (TrackId == undefined ? '' : `TrackId=${TrackId}`),
            'GET',
        );
    }
    public static async SaveGeofenceToEvent(EventId: number, geoFence: GeoFenceRectangle): Promise<boolean | null> {
        return this.Post(`Track/SaveGeofenceToEvent` + '?' + (EventId == undefined ? '' : `EventId=${EventId}`), geoFence);
    }
    public static async GetEventGeofence(EventId: number): Promise<GeoFenceRectangle | null> {
        return this.BaseFetch(
            GeoFenceRectangle,
            `Track/GetEventGeofence` + '?' + (EventId == undefined ? '' : `EventId=${EventId}`),
            'GET',
        );
    }
    public static async GetTracksGeofence(EventId: number, trackids: IntArray, paddingKm: number): Promise<GeoFenceRectangle | null> {
        return this.BaseFetch(
            GeoFenceRectangle,
            `Track/GetTracksGeofence` +
                '?' +
                (EventId == undefined ? '' : `EventId=${EventId}`) +
                '&' +
                (paddingKm == undefined ? '' : `paddingKm=${paddingKm}`),
            'POST',
            trackids,
        );
    }
    public static async GetMapPointsForContestant(EventId: number, racecontestantId: number): Promise<MapPoint[]> {
        return this.BaseFetchArray(
            MapPoint,
            `Track/Racecontestant/MapPoints` +
                '?' +
                (EventId == undefined ? '' : `EventId=${EventId}`) +
                '&' +
                (racecontestantId == undefined ? '' : `racecontestantId=${racecontestantId}`),
            'GET',
        );
    }
    public static async GetLastPositionForContestants(EventId: number, racecontestantIds: IntArray): Promise<RaceContestantPosition[]> {
        return this.BaseFetchArray(
            RaceContestantPosition,
            `Track/Racecontestant/LastPositions` + '?' + (EventId == undefined ? '' : `EventId=${EventId}`),
            'POST',
            racecontestantIds,
        );
    }
    public static async SetRaceContestantPosition(EventId: number, request: RaceContestantTrackingUpdateRequest): Promise<boolean | null> {
        return this.Post(`Track/Racecontestant/SetPosition` + '?' + (EventId == undefined ? '' : `EventId=${EventId}`), request);
    }
    public static async SetRaceContestantSpeed(EventId: number, request: RaceContestantTrackingUpdateRequest): Promise<boolean | null> {
        return this.Post(`Track/Racecontestant/SetSpeed` + '?' + (EventId == undefined ? '' : `EventId=${EventId}`), request);
    }
    public static async SetRaceContestantIgnoreTracking(
        EventId: number,
        request: RaceContestantTrackingUpdateRequest,
    ): Promise<boolean | null> {
        return this.Post(`Track/Racecontestant/SetIgnoreTracking` + '?' + (EventId == undefined ? '' : `EventId=${EventId}`), request);
    }
    public static async TypeAheadSearch(EventId: number, request: SearchRequest): Promise<TypeAheadResponse | null> {
        return this.BaseFetch(
            TypeAheadResponse,
            `Track/TypeAhead` + '?' + (EventId == undefined ? '' : `EventId=${EventId}`),
            'POST',
            request,
        );
    }
    public static async AssignTraccarId(EventId: number, contestantIds: IntArray): Promise<boolean | null> {
        return this.Post(`Track/AssignTraccarId` + '?' + (EventId == undefined ? '' : `EventId=${EventId}`), contestantIds);
    }
    public static async DisableTraccarForContestants(EventId: number): Promise<boolean | null> {
        return this.Delete(`Track/DisableTraccarForContestants` + '?' + (EventId == undefined ? '' : `EventId=${EventId}`));
    }
    public static async GetEventsWithTraccarDevices(): Promise<EventinfoBase[]> {
        const { user } = useUserStore();
        if (user === null || !user.IsSuperAdmin) {
            return [];
        }
        return this.BaseFetchArray(EventinfoBase, `Track/GetEventsWithTraccarDevices`, 'GET');
    }
}
